import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-address-submission-in-progress-banner',
  templateUrl: './address-submission-in-progress-banner.component.html',
  styleUrls: ['./address-submission-in-progress-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressSubmissionInProgressBannerComponent {
  @Output() viewSubmission = new EventEmitter<void>();
}
